import React from 'react'
import {orderBy} from 'lodash'

import Grid from '@mui/material/Grid';
import Avatar from '@mui/material/Avatar'
import Box from '@mui/material/Box';

import useStyles from '../styles'

export default function Legend ({context}) {

    const classes = useStyles()

    const {translate, quizStandardScale = {}} = context;

    const scale = orderBy(Object.values(quizStandardScale[0] || {}), 'index');

    return(	
        <Grid 
        container
        className={classes.legend} 
        > 
            {scale && scale.map(({index, color, label, maxValue, minValue}) => (
                    <Grid item xs={4} md={2}  className={classes.legendBox} key={index}>
                        <Grid item xs={2}>
                            <Avatar 
                                className={classes.legendDot}  
                                style={{"backgroundColor": color}}>
                                    <span></span>
                            </Avatar>
                        </Grid>
                        <Grid item xs={10} className={classes.legendLabel}>
                            <Box>
                                { translate(`standards-${label}`)}
                            </Box>
                            <span>
                                {`${maxValue}% - ${minValue}%`}
                            </span>
                        </Grid>
                    </Grid>
            ))}
        </Grid>
    )
}
